import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { DashboardsService } from '../dashboards.service';
import { ParametroGrafico } from '../../comum/modelos/parametro-grafico';
import { DashboardTileComponent } from '../dashboard-tile/dashboard-tile.component';
import { IndicadorService } from '../../indicador/indicador.service';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { PontoFisicoParametroGrafico } from '../../comum/modelos/ponto-fisico-parametro-grafico';
import { TipoPontoFisicoParametroGrafico } from '../../comum/modelos/tipo-ponto-fisico-parametro-grafico';
import { RegiaoParametroGrafico } from '../../comum/modelos/regiao-parametro-grafico';
import { AuthService } from '../../auth/auth.service';
import { UsuarioParametroGrafico } from '../../comum/modelos/usuario-parametro-grafico';
import { AreaParametroGrafico } from '../../comum/modelos/area-parametro-grafico';

@Component({
  selector: 'app-visualizar-dashboard',
  templateUrl: './visualizar-dashboard.component.html',
  styleUrls: ['./visualizar-dashboard.component.css']
})
export class VisualizarDashboardComponent implements OnInit {
  @ViewChild('dynamic', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  rootViewContainer: ViewContainerRef;

  index: number;

  colorScheme = {
    domain: ['#a8385d', '#7aa3e5', '#a27ea8', '#aae3f5', '#adcded', '#a95963', '#8796c0', '#7ed3ed', '#50abcc', '#ad6886']
  };

  idDashboard: number;
  public loading = false;
  public statusCode: number;


  public setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }
  constructor(
    private _dashboardsService: DashboardsService,
    private _indicadorService: IndicadorService,
    private _activatedRoute: ActivatedRoute,
    private factoryResolver: ComponentFactoryResolver,
    public _authService: AuthService) {
  }

  ngOnInit() {
    this.setRootViewContainerRef(this.viewContainerRef);
    this.index = 0;
    this.idDashboard = this._activatedRoute.snapshot.params['id'];
    this._dashboardsService.obterParametrosGraficosHttp(this.idDashboard)
      .subscribe(parametrosGrafico => {
        parametrosGrafico.forEach(parametroGrafico => {
          parametroGrafico.view = [parametroGrafico.tamanhoColuna, 300];
          forkJoin(this._dashboardsService.obterPontosFisicosParametroGraficoHttp(parametroGrafico.idParametroGrafico),
            this._dashboardsService.obterTiposPontoFisicoParametroGraficoHttp(parametroGrafico.idParametroGrafico),
            this._dashboardsService.obterRegioesParametroGraficoHttp(parametroGrafico.idParametroGrafico),
            this._dashboardsService.obterUsuariosParametroGraficoHttp(parametroGrafico.idParametroGrafico),
            this._dashboardsService.obterAreasParametroGraficoHttp(parametroGrafico.idParametroGrafico))
            .subscribe(([pontosFisicos, tiposPontoFisico, regioes, usuarios, areas]) => {
              parametroGrafico.pontosFisicosParametroGrafico = pontosFisicos;
              parametroGrafico.tiposPontoFisicoParametroGrafico = tiposPontoFisico;
              parametroGrafico.regioesParametroGrafico = regioes;
              parametroGrafico.usuariosParametroGrafico = usuarios;
              parametroGrafico.areasParametroGrafico = areas;
              this.insertDashboardTileComponent(parametroGrafico);
              this._dashboardsService.obterMaiorPosicaoGraficoHttp(this.idDashboard)
                .subscribe(maiorId => {
                  this.index = maiorId.posicao;
                });
            });
        });
      });
  }

  insertDashboardTileComponent(parametroGrafico: ParametroGrafico): void {
    const factory = this.factoryResolver.resolveComponentFactory(DashboardTileComponent);
    const component = this.rootViewContainer.createComponent(factory);
    component.instance.parametroGrafico = parametroGrafico;
    this.popularDadosGrafico(parametroGrafico, component);
    // REMOVER
    component.instance.parametroGraficoExcluirOutput.subscribe((data: ParametroGrafico) => {
      this._dashboardsService.removerParametroGraficoHttp(data.idParametroGrafico)
        .subscribe(() => {
          this.remover(component);
        });
    });
    // ALTERAR
    component.instance.parametroGraficoAlterarOutput.subscribe((data: ParametroGrafico) => {
      this._indicadorService.obterIndicadorPorIdHttp(parametroGrafico.indicador.idIndicador)
        .subscribe(indicador => {
          this._dashboardsService.atualizarParametroGraficoHttp(data)
            .subscribe(param => {
              component.instance.parametroGrafico = param.body;
              component.instance.parametroGrafico.indicador = indicador;
              component.instance.parametroGrafico.view = [param.body.tamanhoColuna, 300];
              this.popularDadosGrafico(data, component);
              component.instance.ngOnInit();
            });
        });
    });
    this.rootViewContainer.insert(component.hostView);
  }

  popularDadosGrafico(parametroGrafico: ParametroGrafico, component: any) {
    if (parametroGrafico.tipoGrafico === 'bar-vertical-2d'
      || parametroGrafico.tipoGrafico === 'bar-horizontal-2d'
      || parametroGrafico.tipoGrafico === 'line') {
      this._dashboardsService.obterDashboardMultiHttp(parametroGrafico)
        .subscribe(resultadoDashboardMulti => {
          component.instance.resultadoDashboardMulti = resultadoDashboardMulti.body;
          component.instance.resultadoDashboardMulti.chartData = new Array<any>();
          component.instance.resultadoDashboardMulti.resultados.map(function (resultadoDashboard) {
            const series = new Array<any>();
            resultadoDashboard.resultados.map(function (resultadoIndicador) {
              series.push({
                name: resultadoIndicador.label,
                value: resultadoIndicador.valorIndicador
              });
            });
            component.instance.resultadoDashboardMulti.chartData.push({
              name: resultadoDashboard.nomePontoFisico,
              series
            });
          });
          component.instance.resultadoDashboardMulti.chartData = [...component.instance.resultadoDashboardMulti.chartData];
        });
    } else {
      this._dashboardsService.obterDashboardSingleHttp(parametroGrafico)
        .subscribe(resultadoDashboardSingle => {
          component.instance.resultadoDashboardSingle = resultadoDashboardSingle.body;
          component.instance.resultadoDashboardSingle.chartData = new Array<any>();
          component.instance.resultadoDashboardSingle.resultados.map(function (resultadoIndicador) {
            component.instance.resultadoDashboardSingle.chartData.push({
              name: resultadoIndicador.label,
              value: resultadoIndicador.valorIndicador
            });
          });
          component.instance.resultadoDashboardSingle.chartData = [...component.instance.resultadoDashboardSingle.chartData];
        });
    }
  }

  remover(component: any): void {
    const i = this.rootViewContainer.indexOf(component);
    this.rootViewContainer.remove(i);
  }

  receberParametrosGrafico(parametroGrafico: ParametroGrafico) {
    forkJoin(
      this._dashboardsService.obterMaiorPosicaoGraficoHttp(this.idDashboard),
      this._indicadorService.obterIndicadorPorIdHttp(parametroGrafico.indicador.idIndicador))
      .subscribe(([maiorPosicao, indicador]) => {
        this.index = maiorPosicao.posicao;
        parametroGrafico.posicaoGrafico = ++this.index;
        parametroGrafico.idDashboard = this.idDashboard;
        parametroGrafico.indicador = indicador;
        let parGrf = new ParametroGrafico();
        this._dashboardsService.cadastrarParametroGraficoHttp(parametroGrafico)
          .subscribe(param => {
            parGrf = param.body;
            parGrf.view = [parGrf.tamanhoColuna, 300];
            const pfpg = new Array<PontoFisicoParametroGrafico>();
            for (const pontoFPG of parametroGrafico.pontosFisicosParametroGrafico) {
              if (pontoFPG.idParametroGrafico === null || pontoFPG.idParametroGrafico === undefined) {
                pontoFPG.idParametroGrafico = param.body.idParametroGrafico;
                pfpg.push(pontoFPG);
              }
            }
            const tpfpg = new Array<TipoPontoFisicoParametroGrafico>();
            for (const tipoPFPG of parametroGrafico.tiposPontoFisicoParametroGrafico) {
              if (tipoPFPG.idParametroGrafico === null || tipoPFPG.idParametroGrafico === undefined) {
                tipoPFPG.idParametroGrafico = param.body.idParametroGrafico;
                tpfpg.push(tipoPFPG);
              }
            }
            const rpg = new Array<RegiaoParametroGrafico>();
            for (const regiaoPG of parametroGrafico.regioesParametroGrafico) {
              if (regiaoPG.idParametroGrafico === null || regiaoPG.idParametroGrafico === undefined) {
                regiaoPG.idParametroGrafico = param.body.idParametroGrafico;
                rpg.push(regiaoPG);
              }
            }
            const upg = new Array<UsuarioParametroGrafico>();
            for (const usuarioPG of parametroGrafico.usuariosParametroGrafico) {
              if (usuarioPG.idParametroGrafico === null || usuarioPG.idParametroGrafico === undefined) {
                usuarioPG.idParametroGrafico = param.body.idParametroGrafico;
                upg.push(usuarioPG);
              }
            }
            const apg = new Array<AreaParametroGrafico>();
            for (const areaPG of parametroGrafico.areasParametroGrafico) {
              if (areaPG.idParametroGrafico === null || areaPG.idParametroGrafico === undefined) {
                areaPG.idParametroGrafico = param.body.idParametroGrafico;
                apg.push(areaPG);
              }
            }
            forkJoin(this._dashboardsService.cadastrarPontosFisicosParametroGraficoHttp(pfpg),
              this._dashboardsService.cadastrarTiposPontoFisicoParametroGraficoHttp(tpfpg),
              this._dashboardsService.cadastrarRegioesParametroGraficoHttp(rpg),
              this._dashboardsService.cadastrarUsuariosParametroGraficoHttp(upg),
              this._dashboardsService.cadastrarAreasParametroGraficoHttp(apg))
              .subscribe(([pontosFisicos, tiposPontoFisico, regioes, usuarios, areas]) => {
                parGrf.pontosFisicosParametroGrafico = pontosFisicos.body;
                parGrf.tiposPontoFisicoParametroGrafico = tiposPontoFisico.body;
                parGrf.regioesParametroGrafico = regioes.body;
                parGrf.usuariosParametroGrafico = usuarios.body;
                parGrf.areasParametroGrafico = areas.body;
              });
            this.insertDashboardTileComponent(parGrf);
          });
      });
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/visualizar-dashboard/visualizar-dashboard.component.ts